/**
 * Socle visuel du monitoring.
 *
 * Contrastes (m-10), vérifiés par `shared/contrast.test.ts` :
 * - toute couleur employée pour du TEXTE (encres, états, et le blanc des
 *   étiquettes posé sur une couleur d'état) atteint 4,5:1 (WCAG AA) ;
 * - les teintes de séries, qui colorent des traits et des aplats, atteignent au
 *   moins 3:1 sur fond blanc (WCAG 1.4.11). Chaque graphique garde en plus une
 *   vue « tableau » qui lève toute dépendance à la couleur seule.
 *
 * Il n'y a plus ici ni formateur (voir `shared/format.ts`, localisé) ni
 * construction de CSV : les exports sont produits par le serveur (D-25).
 */
import type { CSSProperties } from 'react';

/** Teintes catégorielles des séries, attribuées une fois pour toutes par `shared/seriesRegistry.ts`. */
export const MONITORING_PALETTE = {
    blue: '#1F78B4',
    orange: '#D35400',
    green: '#0E8A5F',
    ochre: '#A06A00',
    violet: '#6D4FC2',
    magenta: '#C2185B',
    teal: '#00838F',
    slate: '#5D6D7E',
} as const;

/**
 * Couleurs d'état : réservées aux états, jamais à une série. Toujours
 * accompagnées d'un libellé. Contraste texte ≥ 4,5:1 sur blanc, et blanc ≥
 * 4,5:1 sur elles (étiquettes pleines).
 */
export const STATE_COLORS = {
    good: '#047857',
    warning: '#B45309',
    critical: '#C62828',
    neutral: '#595959',
} as const;

export const INK = {
    primary: '#0F172A',
    secondary: '#475569',
    /** Texte secondaire discret : 4,76:1 (l'ancien #94A3B8 plafonnait à 2,56:1). */
    muted: '#64748B',
    border: '#E2E8F0',
    surface: '#FFFFFF',
};

export const cardStyle: CSSProperties = {
    borderRadius: 14,
    border: `1px solid ${INK.border}`,
    boxShadow: '0 2px 10px rgba(15, 23, 42, 0.04)',
};

/** Axes et grille volontairement discrets : la donnée doit primer. */
export const AXIS_STYLE = {
    line: true,
    lineStroke: INK.border,
    tickStroke: INK.border,
    labelFill: INK.secondary,
    labelFontSize: 11,
    gridStroke: INK.border,
    gridLineDash: [3, 3],
};
